module.exports = __webpack_public_path__ + "static/media/tick.d059274a.svg";